import { createClient } from '@/shared/api';
import type { UnreviewedReportsQuery, UnreviewedReportsQueryVariables } from '@/shared/api';
import UNREVIEWED_REPORTS_QUERY from '../queries/unreviewedReports';

/**
 * Loads a page of unreviewed reports. Runs the unreviewedReports query with the filter and limit and returns the payload as-is without checking for errors.
 *
 * @param filter - Filter selecting the unreviewed reports.
 * @param limit - Maximum number of reports to load; defaults to 10.
 * @returns A promise resolving to the unreviewed reports payload.
 */
const fetchUnreviewedReports = async (
  filter: UnreviewedReportsQueryVariables['filter'],
  limit = 10,
): Promise<UnreviewedReportsQuery['unreviewedReports'] | undefined> => {
  const client = createClient();
  const unreviewedReportsResult = await client.query<
    UnreviewedReportsQuery,
    UnreviewedReportsQueryVariables
  >({
    query: UNREVIEWED_REPORTS_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data } = unreviewedReportsResult;
  return data?.unreviewedReports;
};

export default fetchUnreviewedReports;
